export default (n, precision = 100) => 
    Math.round(n * precision) / precision;
